import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {GroupMember} from '../../../graphql/groups.datatypes';
import {gqlGroupMember} from './getGroupMembers.api';

interface GroupMembersData {
    groupMembersInMyGroup: void
    groupMembers: void,
    myTravellers: void,
    myGroupMembers: {
        data: GroupMember[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_GROUP_MEMBERS_QUERY = gql`
  query getMyGroupMembers($count: Int!, $page: Int!, $where: WhereConditions, $hasRoomMember: QueryMyGroupMembersHasRoomMemberWhereHasConditions, $orderBy: [OrderByClause!]){
    myGroupMembers(first: $count, page: $page, where: $where, hasRoomMember: $hasRoomMember, orderBy: $orderBy){
      data {
        ${gqlGroupMember}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getMyGroupMembers = (count: number, page: number, where?: any, orderBy?: any, hasRoomMember?: any) => useQuery<GroupMembersData>(
    GET_GROUP_MEMBERS_QUERY,
    {
        variables: {
            count,
            page,
            where,
            orderBy,
            hasRoomMember,
        },
    }
);

export default getMyGroupMembers;
